import React from 'react';
import styled from 'styled-components';
import {colors} from '../../../styleVariables';
import DatePicker from './datePiker';
import {useIntl} from 'react-intl';
import {REPORT_MAX_DAYS} from '../../../helpers/report';

const LIMIT_IN_MILLIS = REPORT_MAX_DAYS * 86400000;

const shiftedBy = (date, millis) => (date ? new Date(date.getTime() + millis) : null);

const earliest = (...dates) => new Date(Math.min(...dates.filter(Boolean).map(Number)));

const ErrorDate = styled.div`
  width: 100%;
  span {
    font-size: 80%;
    font-weight: 400;
    color: ${colors.red};
  }
`;

const PeriodDate = ({setStartDate, setEndDate, startDate, endDate}) => {
    const intl = useIntl();
    // Visual guard only: a preset period never goes through these pickers, so the rule that decides
    // is the one in the schema.
    const startFloor = shiftedBy(endDate, -LIMIT_IN_MILLIS);
    const endCeiling = earliest(new Date(), shiftedBy(startDate, LIMIT_IN_MILLIS));
    return (
        <div className="d-flex mt-3">
            <ErrorDate>
                <DatePicker
                    onSelect={setStartDate}
                    timeInputLabel="Time:"
                    dateFormat="dd/MM/yyyy HH:mm"
                    showTimeInput
                    className=""
                    placeholderText={intl.formatMessage({id: 'sharedSelect'})}
                    minDate={startFloor}
                    maxDate={endDate || new Date()}
                    name="startDate"
                    selected={startDate}
                    onChange={setStartDate}
                />
            </ErrorDate>
            <span className="text-gray mx-2">{intl.formatMessage({id: 'sharedUntil'})}</span>
            <ErrorDate>
                <DatePicker
                    onSelect={setEndDate}
                    timeInputLabel="Time:"
                    dateFormat="dd/MM/yyyy HH:mm"
                    showTimeInput
                    className=""
                    placeholderText={intl.formatMessage({id: 'sharedSelect'})}
                    minDate={startDate}
                    maxDate={endCeiling}
                    name="endDate"
                    selected={endDate}
                    onChange={setEndDate}
                />
            </ErrorDate>
        </div>
    );
};

export default PeriodDate;
